// extracted by mini-css-extract-plugin
module.exports = {"boxButtonPaginator":"ShowMoreButton_boxButtonPaginator__3X5Uc","isLoading":"ShowMoreButton_isLoading__2S4Mp","buttonPaginator":"ShowMoreButton_buttonPaginator__1q7h4"};